export default class MicroblinkError extends Error {
  public name = 'MicroblinkError';
  public originalError: EventFatalError;

  constructor(microblinkError: EventFatalError) {
    super(microblinkError.message);
    this.originalError = microblinkError;
  }

  static fromString(error: string) {
    return new MicroblinkError({ message: error });
  }
}

export enum Code {
  BrowserNotSupported = 'BROWSER_NOT_SUPPORTED',
  EmptyResult = 'EMPTY_RESULT',
  InvalidRecognizers = 'INVALID_RECOGNIZERS',
  InvalidRecognizerOptions = 'INVALID_RECOGNIZER_OPTIONS',
  MissingLicenseKey = 'MISSING_LICENSE_KEY',
  NoImageFileFound = 'NO_IMAGE_FILE_FOUND',
  SdkLoadFailed = 'SDK_LOAD_FAILED',
  GenericScanError = 'GENERIC_SCAN_ERROR',
  CameraNotAllowed = 'CAMERA_NOT_ALLOWED',
  CameraInUse = 'CAMERA_IN_USE',
  CameraGenericError = 'CAMERA_GENERIC_ERROR',
  InternetNotAvailable = 'INTERNET_NOT_AVAILABLE',
  LicenseError = 'LICENSE_ERROR',
}

export type EventFatalError = {
  code?: Code;
  message: string;
  details?: any;
};
